export default authorisation => ({
  Authorization: authorisation,
  "Content-Type": "application/json"
});
